import axios from "axios";

const api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
  },
});

export default api;
